import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { RDSAnalysisData } from '../../../model/analysis-details.model';
import { DBService } from '../../../service/DB.service';
import { StorageService } from '../../../service/storage.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import _moment, { default as _rollupMoment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-previous-data-summary',
  standalone: true,
  imports: [],
  templateUrl: './previous-data-summary.component.html',
  styleUrl: './previous-data-summary.component.scss',
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class PreviousDataSummaryComponent implements OnInit, OnDestroy {

  previousAnalysisKeys: RDSAnalysisData[] = [];
  pageLoaded = false;
  private rdsAnalysisDataSubscription?: Subscription;
  startDate: string | undefined;
  endDate: string | undefined;
  maxDate = new Date();
  auditFlag = false;
  dateRangeStart?: moment.Moment | null;
  dateRangeEnd?: moment.Moment | null;
  userAttributes?: string | null;
  dataCompile:boolean=true;

  @ViewChild('RApaginator', { static: false }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort?: MatSort;
  dataSource?: MatTableDataSource<RDSAnalysisData>;
  tableColumns: string[] = ['analyteName', 'analysisType', 'analysisDate', 'projectNames'];
  searchResults: RDSAnalysisData[] = [];
  @ViewChild('htmlData1') htmlData1!: ElementRef;

  constructor(
    private dbService: DBService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {

    this.userAttributes = this.storageService.get('access');
    if (this.userAttributes == 'PI') {
      this.pageLoaded = false;
    }

    else if (this.userAttributes == 'GA' || this.userAttributes == 'SU' || this.userAttributes == 'QA') {
      this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);
      this.rdsAnalysisDataSubscription = this.dbService.rdsAnalysisData.subscribe(
        (data: RDSAnalysisData[]) => {
          this.previousAnalysisKeys = data;
          this.searchResults = data;
          this.pageLoaded = true;
          this.displayData();
        });
    }
  }

  displayData() {
    this.dataSource = new MatTableDataSource(this.searchResults);
    setTimeout(() => this.dataSource!.paginator = this.paginator ?? null);
    setTimeout(() => this.dataSource!.sort = this.sort ?? null);

  }


  public openPDF1(): void {
    const DATA: any = document.getElementById('htmlData1');
    html2canvas(DATA).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      const PDF = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('report-analysis.pdf');
    });
  }

  getUrl(analysisType: string) {
    if (analysisType === 'qPCR-Compilation') {
      return '/default-layout/qpcr-molecule-analysis';
    }
    else {
      return '/default-layout/notfound';
    }

  }

  applyFilter(filterValue: string) {
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  selectedDates() {
    this.startDate = this.dateRangeStart?.format('MM/DD/YYYY');
    this.endDate = this.dateRangeEnd?.format('MM/DD/YYYY');
    this.previousAnalysisKeys = [];
    this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);
  }


  clearSelectedDates() {
    this.previousAnalysisKeys = [];
    this.dateRangeEnd = null;
    this.dateRangeStart = null;
    this.startDate = 'none';
    this.endDate = 'none';
    this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);

  }

  ngOnDestroy() {
    if (this.rdsAnalysisDataSubscription) {
      this.rdsAnalysisDataSubscription.unsubscribe();
    }
  }
}

